// NOTE: Keep OperationsEnum & MediaLibOperationsEnum in sync
// w/ the image-server-dashboard/utils/operations.js so that UI & Backend service are showing the same values.

export const OperationsEnum = {
  UPDATE_CLIENT_WIDE_MULTIFACTOR_AUTHENTICATION:
    'Update client wide multi-factor authentication',
  ADD_EXTERNAL_STORAGE: 'Add external storage',
  UPDATE_EXTERNAL_STORAGE: 'Update external storage',
  DELETE_EXTERNAL_STORAGE: 'Delete external storage',
  ADD_URL_ENDPOINT: 'Add URL endpoint',
  UPDATE_URL_ENDPOINT: 'Update URL endpoint',
  DELETE_URL_ENDPOINT: 'Delete URL endpoint',
  ADD_USER: 'Add user',
  DELETE_USER: 'Delete user',
  UPDATE_USER: 'Update user',
  ROLL_KEYS: 'Roll keys',
  DELETE_KEYS: 'Delete keys',
  CREATE_RESTRICTED_KEYS: 'Create restricted keys',
  UPDATE_RESTRICTED_KEYS: 'Update restricted keys',
  CANCEL_SUBSCRIPTION: 'Cancel subscription',
  UPDATE_SETTINGS: 'Update settings',
  UPDATE_BACKUP_BUCKET: 'Update backup bucket',
  DELETE_BACKUP_BUCKET: 'Delete backup bucket',
  ADD_PURGE_CACHE_URL_LIST: 'Add URL lists for purging cache',
  UPDATE_BILLING_DETAILS: 'Update billing details',
  ADD_BILLING_ALERTS: 'Add billing alerts',
  REMOVE_BILLING_ALERTS: 'Remove billing alerts',
  UPDATE_PAYMENT_SOURCE: 'Update payment source',
  ADD_URL_PERFORMANCE_TRACK: 'Add URL for performance tracking',
  UPDATE_URL_PERFORMANCE_TRACK: 'Update tracked URL in performance center',
  DELETE_URL_PERFORMANCE_TRACK: 'Delete tracked URL in performance center',
  UPDATE_PERFORMANCE_ALERTS: 'Update performance alerts',
  ADD_BACKUP_BUCKET: 'Add backup bucket',
  UPDATE_SECURITY_SETTINGS: 'Update advanced security settings',
  ADD_WEBHOOKS: 'Add webhooks',
  UPDATE_WEBHOOKS: 'Update webhooks',
  DELETE_WEBHOOKS: 'Delete webhooks',
  ADD_SINGLE_SIGN_ON_METADATA_XML: 'Add SSO configuration',
  UPDATE_SINGLE_SIGN_ON_METADATA_XML: 'Update SSO configuration',
  DELETE_SINGLE_SIGN_ON_METADATA_XML: 'Delete SSO configuration',
  CREATE_USER_GROUP: 'Create user group',
  UPDATE_USER_GROUP: 'Update user group',
  DELETE_USER_GROUP: 'Delete user group',
  CREATE_PUBLIC_LINK: "Create public link",
  UPDATE_PUBLIC_LINK: "Update public link",
  DELETE_PUBLIC_LINK: "Delete public link",
  GENERATE_IMAGE_FROM_TEXT: "Generate image from text",
  DELETE_IMAGE_GENERATED_FROM_TEXT: "Delete image generated from text",
  CREATE_BOOKMARK: "Create bookmark",
  UPDATE_BOOKMARK: "Update bookmark",
  DELETE_BOOKMARK: "Delete bookmark",
  CREATE_SAVED_SEARCH: "Create saved search",
  UPDATE_SAVED_SEARCH: "Update saved search",
  DELETE_SAVED_SEARCH: "Delete saved search",
  CREATE_PATH_POLICY: "Create path policy",
  UPDATE_PATH_POLICY: "Update path policy",
  DELETE_PATH_POLICY: "Delete path policy",
  CREATE_EXTENSION_PRESET: "Create extension preset",
  UPDATE_EXTENSION_PRESET: "Update extension preset",
  DELETE_EXTENSION_PRESET: "Delete extension preset",
}

export const MediaLibOperationEnum = {
  UPDATE_FILE: {
    label: 'Updated file details',
    value: 'file.update',
  },
  UPDATE_FOLDER: {
    label: 'Updated folder',
    value: 'folder.update',
  },
  APPLY_EXTENSION: {
    label: 'Applied extension',
    value: 'file.apply_extension',
  },
  ADD_FILE_TAGS: {
    label: 'Added tags',
    value: 'file.add_tags',
  },
  REMOVE_FILE_TAGS: {
    label: 'Removed tags',
    value: 'file.remove_tags',
  },
  ADD_AI_TAGS: {
    label: 'Added AI tags',
    value: 'file.add_ai_tags',
  },
  REMOVE_FILE_AI_TAGS: {
    label: 'Removed AI tags',
    value: 'file.remove_ai_tags',
  },
  RENAME_FILE: {
    label: 'Renamed file',
    value: 'file.rename',
  },
  RENAME_FOLDER: {
    label: 'Renamed folder',
    value: 'folder.rename',
  },
  CREATE_FILE_VERSION: {
    label: 'Created file version',
    value: 'file.create_version',
  },
  RESTORE_FILE_VERSION: {
    label: 'Restored file version',
    value: 'file.version_restore',
  },
  DELETE_FILE_VERSION: {
    label: 'Deleted file version',
    value: 'file.version_delete',
  },
  DELETE_FILE: {
    label: 'Deleted file',
    value: 'file.delete',
  },
  DELETE_FILE_BY_MOVE: {
    label: 'Deleted file by moving',
    value: 'file.delete_by_move',
  },
  DELETE_FOLDER: {
    label: 'Deleted folder',
    value: 'folder.delete',
  },
  DELETE_FOLDER_BY_MOVE: {
    label: 'Deleted folder by moving',
    value: 'folder.delete_by_move',
  },
  CHANGE_PUBLISH_STATUS: {
    label: 'Changed publish status for file',
    value: 'file.change_publish_status',
  },
  CHANGE_ACCESS_CONTROL: {
    label: 'Changed access control for asset',
    value: 'change_access_control',
  },
  ADD_PUBLIC_LINK: {
    label: 'Added public link to asset',
    value: 'add_public_link',
  },
  UPDATE_PUBLIC_LINK: {
    label: 'Updated public link to asset',
    value: 'update_public_link',
  },
  DELETE_PUBLIC_LINK: {
    label: 'Deleted public link to asset',
    value: 'delete_public_link',
  },
  ADD_ASSETS_MEDIA_COLLECTION: {
    label: 'Added assets to media collection',
    value: 'media-collection.add_assets',
  },
  REMOVE_ASSETS_MEDIA_COLLECTION: {
    label: 'Removed assets from media collection',
    value: 'media-collection.remove_assets',
  },
  RENAME_MEDIA_COLLECTION: {
    label: 'Renamed media collection',
    value: 'media-collection.rename',
  },
  UPDATE_MEDIA_COLLECTION: {
    label: 'Updated media collection',
    value: 'media-collection.update',
  },
  DELETE_MEDIA_COLLECTION: {
    label: 'Deleted media collection',
    value: 'media-collection.delete',
  },
} as const

export const NotificationsOperationsEnum = {
  ADD_COMMENT: 'Add comments in asset',
  DELETE_THREAD: 'Delete thread in asset',
  SET_THREAD_RESOLUTION: 'Set thread resolution in asset',
  SHARE_ASSET: 'Share asset',
}
